import { EpimsBaseEntityDto } from './epim-base.dto';
export class IncidentOwnerMappingDto extends EpimsBaseEntityDto {
  
  AssetLocationId: string;
  AssetLocationName: string;
  StaffId: string;
  StaffName: string;
  SubscriptionUserId: string;  
  Version: number;
}
